import * as React from 'react';
import { cn } from '@/lib/utils';

const AttemptModalHeader = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-attempt-modal-header',
        // styles
        'flex items-center justify-between',
        'border-b border-solid border-bright',
        'mb-5',
        className
      )}
      {...props}
    />
  );
});
AttemptModalHeader.displayName = 'AttemptModalHeader';

const AttemptCardWrapper = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-attempt-card-wrapper',
        // styles
        'border border-solid border-neutral-lightest',
        'rounded-md',
        'shadow-dropshadow',
        'px-5',
        className
      )}
      {...props}
    />
  );
});
AttemptCardWrapper.displayName = 'AttemptCardWrapper';

const AttemptCard = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-attempt-card',
        // styles
        'flex min-h-[51px] cursor-pointer items-center justify-between bg-white',
        className
      )}
      {...props}
    />
  );
});
AttemptCard.displayName = 'AttemptCard';

const AttemptCardTitle = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        'c-attempt-card-title',
        // styles
        'whitespace-nowrap text-sm font-bold text-primary-dark',
        className
      )}
      {...props}
    />
  );
});
AttemptCardTitle.displayName = 'AttemptCardTitle';

export { AttemptModalHeader, AttemptCardWrapper, AttemptCard, AttemptCardTitle };
